/**
 * Titres de section des panneaux, une seule typographie partout : majuscules
 * grasses et espacées, dans la couleur de leur section (cf. editorAccents).
 *
 * À droite (inspecteur), le titre est en plus souligné de sa couleur. À gauche
 * (palettes, infos du document), la couleur suffit : un trait sous chaque
 * groupe chargeait la colonne.
 */
export const PANEL_HEADING_STYLE = {
  fontWeight: 700,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
};

export const underlinedPanelHeadingStyle = (color) => ({
  ...PANEL_HEADING_STYLE,
  display: 'inline-block',
  color,
  borderBottom: `2px solid ${color}`,
  paddingBottom: 4,
});

/**
 * Sous-groupe d'une section de l'inspecteur : même trait que le titre de
 * section, en plus petit. Sert à porter le contexte que des libellés courts ne
 * portent plus — sous « Illustration », « Couleur » se comprend seul.
 */
export const panelGroupLabelStyle = (color) => ({
  ...underlinedPanelHeadingStyle(color),
  fontSize: 11,
  width: 'fit-content',
});
